import { Outlet } from "react-router";
import AppVersion from "../sharable/AppVersion.jsx";
import { useAccountStatusLoader } from "./useAccountStatusLoader.js";
import { useUserAuthenticated } from "./useUserAuthenticated.js";
import { useUserLoader } from "./useUserLoader.js";

export default function SecureRoutes() {
  const { token, userId } = useUserAuthenticated();
  const { user, setUser } = useUserLoader({ token, userId });
  const { accountStatus } = useAccountStatusLoader({ token, user });

  return (
    <>
      {token && user && accountStatus ? (
        <Outlet
          context={{
            token: token,
            user: user,
            setUser: setUser,
            activeAccount: accountStatus?.isAccountActive,
            isAccountPremium: accountStatus?.isAccountPremium,
            accessExpiryDate: accountStatus?.accessExpiryDate,
            accountStatus: accountStatus,
          }}
        />
      ) : (
        "Não foi possível carregar os dados do usuário. Por favor, tente novamente."
      )}
      <AppVersion />
    </>
  );
}
